"use strict";
/**
 * This file is part of stream-ext' project.
 * @link     : https://zhaiyiming.com/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2022 TINYMINS.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showLogPosition = exports.log = exports.init = void 0;
const StreamExt = __importStar(require("@jd/stream-ext"));
const show_log_position_1 = __importDefault(require("./show-log-position"));
exports.showLogPosition = show_log_position_1.default;
/**
 * 初始化营销中心埋点
 * @param site yx（营销中心-默认）ace（投放）mc（提报）ms（提报秒杀）
 */
const init = (site = 'yx') => {
    const logType1 = 'yx_common' + (site === 'yx' ? '' : '_' + site);
    StreamExt.monitorClick([
        {
            propName: 'data-yxlogtag-ignore',
            acceptChild: true,
            logType1: '',
            logType2: '',
            transform: () => void 0,
        },
        {
            propName: 'data-yxlogtag',
            acceptChild: true,
            logType1: logType1,
            logType2: 'divclick',
            transform: (e, [type]) => {
                var _a, _b;
                const parts = type.replace(/^prop:data-yxlogtag:/iu, '').split('|');
                const res = [
                    JSON.stringify({
                        site: site,
                        clickId: parts[0],
                        trackId: (_a = parts[1]) !== null && _a !== void 0 ? _a : '',
                        context: (_b = parts[2]) !== null && _b !== void 0 ? _b : '', // 默认为空,上下文从哪里来的，类似ref
                    }),
                ];
                let json = {};
                if (parts[3]) {
                    try {
                        json = JSON.parse(parts[3]);
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                if (e.currentTarget) {
                    try {
                        for (let i = 0; i < e.currentTarget.attributes.length; i++) {
                            const attr = e.currentTarget.attributes.item(i);
                            if (attr) {
                                if (attr.name.startsWith('data-yxlogtag:')) {
                                    json[attr.name.substring('data-yxlogtag:'.length)] =
                                        attr.value;
                                }
                                else if (attr.name.startsWith('data-yxlogtag__')) {
                                    json[attr.name.substring('data-yxlogtag__'.length)] =
                                        attr.value;
                                }
                            }
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                if (Object.entries(json).length > 0) {
                    res.push(JSON.stringify(json));
                }
                return res;
            },
        },
        {
            propName: 'clstag',
            acceptChild: true,
            logType1: '',
            logType2: '',
            transform: () => void 0,
        },
        {
            logType1: logType1,
            logType2: 'otherclick',
            transform: (e, [_, ...rest]) => rest,
        },
    ]);
};
exports.init = init;
/**
 * 调用方法手动上报埋点
 * @param propValue 埋点数据
 */
const log = (propValue) => {
    StreamExt.dispatchLog('data-yxlogtag', propValue);
};
exports.log = log;
